import React from 'react';

interface ICallProps {
    className?: string;
}

const Call = ({className=""}:ICallProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 14.307 22.355">
        <path
            fill="#fff"
            d="M1020.173,84.106a6.923,6.923,0,0,1-4.255-2.325,22.573,22.573,0,0,1-2.109-3.018,26.773,26.773,0,0,1-3.034-7.023,12.411,12.411,0,0,1-.5-4.732A5.863,5.863,0,0,1,1014,61.885c.039-.016.1-.036.168-.059a1.535,1.535,0,0,1,1.8.668q.026.046.049.093c.559,1.151,1.055,2.333,1.571,3.5a1.153,1.153,0,0,1-.643,1.75c-.542.254-1.093.491-1.63.755a1.271,1.271,0,0,0-.683,1.713q1.5,3.508,3.065,6.992a1.214,1.214,0,0,0,1.719.6c.564-.245,1.116-.52,1.68-.765a1.071,1.071,0,0,1,1.587.618q.844,1.89,1.661,3.793a1.1,1.1,0,0,1-.651,1.693c-.683.286-1.391.51-2.093.751Z"
            transform="translate(-1010.207 -61.751)"/>
    </svg>
);

export default Call;